var map = {
	"./Admin/LandingEditor": 4270,
	"./Admin/LandingEditor.vue": 4270,
	"./Admin/landing-edit": 373,
	"./Admin/landing-edit.js": 373,
	"./Blog": 3284,
	"./Blog.vue": 3284,
	"./Careers": 3493,
	"./Careers.vue": 3493,
	"./CareersJob": 8444,
	"./CareersJob.vue": 8444,
	"./Challenge": 6878,
	"./Challenge.vue": 6878,
	"./Company": 1586,
	"./Company.vue": 1586,
	"./ContactSales": 2382,
	"./ContactSales.vue": 2382,
	"./CookiesPolicy": 5972,
	"./CookiesPolicy.vue": 5972,
	"./DemoExample/FaceDemoLayout": 5725,
	"./DemoExample/FaceDemoLayout.vue": 5725,
	"./DemoExample/FaceMatching": 9172,
	"./DemoExample/FaceMatching.vue": 9172,
	"./DemoExample/GalleryIdent": 2829,
	"./DemoExample/GalleryIdent.vue": 2829,
	"./DemoExample/KYC": 367,
	"./DemoExample/KYC.vue": 367,
	"./DemoExample/LivenessDetection": 2074,
	"./DemoExample/LivenessDetection.vue": 2074,
	"./DemoExample/ProcessImage": 8807,
	"./DemoExample/ProcessImage.vue": 8807,
	"./EbookPage": 6915,
	"./EbookPage.vue": 6915,
	"./Ebooks": 9942,
	"./Ebooks.vue": 9942,
	"./EmailPasswordReset": 4235,
	"./EmailPasswordReset.vue": 4235,
	"./Error": 8505,
	"./Error.vue": 8505,
	"./Faqs": 6747,
	"./Faqs.vue": 6747,
	"./GeneralInformationSecurityPolicy": 2043,
	"./GeneralInformationSecurityPolicy.vue": 2043,
	"./Home": 7216,
	"./Home.vue": 7216,
	"./JobApplicantPrivacyPolicy": 7651,
	"./JobApplicantPrivacyPolicy.vue": 7651,
	"./LandingPage": 9861,
	"./LandingPage.vue": 9861,
	"./Login": 214,
	"./Login.vue": 214,
	"./PostPage": 4667,
	"./PostPage.vue": 4667,
	"./Press": 7614,
	"./Press.vue": 7614,
	"./Pricing": 8805,
	"./Pricing.vue": 8805,
	"./PrivacyPolicy": 4644,
	"./PrivacyPolicy.vue": 4644,
	"./Products/YouAge": 4564,
	"./Products/YouAge.vue": 4564,
	"./Products/YouAuth": 990,
	"./Products/YouAuth.vue": 990,
	"./Products/YouFace": 7215,
	"./Products/YouFace.vue": 7215,
	"./Products/YouID": 685,
	"./Products/YouID.vue": 685,
	"./Products/YouLive": 4267,
	"./Products/YouLive.vue": 4267,
	"./Projects": 3619,
	"./Projects.vue": 3619,
	"./Register": 4150,
	"./Register.vue": 4150,
	"./ResetPassword": 6420,
	"./ResetPassword.vue": 6420,
	"./ResponsibleDisclosureProgram": 7434,
	"./ResponsibleDisclosureProgram.vue": 7434,
	"./RoiCalculator": 2918,
	"./RoiCalculator.vue": 2918,
	"./RoiCalculatorV2": 8988,
	"./RoiCalculatorV2.vue": 8988,
	"./TermsConditions": 5906,
	"./TermsConditions.vue": 5906,
	"./UseCases/Banking": 4089,
	"./UseCases/Banking.vue": 4089,
	"./UseCases/Hospitality": 3096,
	"./UseCases/Hospitality.vue": 3096,
	"./UseCases/Igaming": 4083,
	"./UseCases/Igaming.vue": 4083,
	"./UseCases/Mobility": 1075,
	"./UseCases/Mobility.vue": 1075,
	"./User/APIAccess": 3906,
	"./User/APIAccess.vue": 3906,
	"./User/AccountSettings": 6867,
	"./User/AccountSettings.vue": 6867,
	"./User/BillingAddress": 9723,
	"./User/BillingAddress.vue": 9723,
	"./User/Branding": 9371,
	"./User/Branding.vue": 9371,
	"./User/Dashboard": 2025,
	"./User/Dashboard.vue": 2025,
	"./User/Invoices": 7137,
	"./User/Invoices.vue": 7137,
	"./User/Plans": 8316,
	"./User/Plans.vue": 8316,
	"./User/Statistics": 8114,
	"./User/Statistics.vue": 8114,
	"./User/Subscription": 8583,
	"./User/Subscription.vue": 8583,
	"./Videos": 7905,
	"./Videos.vue": 7905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8846;